module.exports = __webpack_public_path__ + "static/venice20890-1135583742c95d8723105eee8fc22fce.png";